export default "__VITE_ASSET__92f85a98__"